import React from 'react';
import './AccessibilityStatement.css';

const AccessibilityStatement = () => {
  return (
    <div className="accessibility-statement" role="main">
      <div className="statement-container">
        <header className="statement-header">
          <h1>Accessibility Statement</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <section className="statement-content">
          <h2>Our Commitment</h2>
          <p>
            RDV Systems is committed to ensuring digital accessibility for people with disabilities. 
            We are continually improving the user experience for everyone and applying the relevant 
            accessibility standards to ensure we provide equal access to all users.
          </p>

          <h2>Conformance Status</h2>
          <p>
            The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and 
            developers to improve accessibility for people with disabilities. It defines three levels 
            of conformance: Level A, Level AA, and Level AAA. RDV Systems is partially conformant 
            with WCAG 2.1 level AA. Partially conformant means that some parts of the content do 
            not fully conform to the accessibility standard.
          </p>

          <h2>Accessibility Features</h2>
          <ul>
            <li>Keyboard navigation support throughout the application</li>
            <li>Screen reader compatibility with proper ARIA labels</li>
            <li>High contrast mode for better visibility</li>
            <li>Adjustable font sizes (12px to 24px)</li>
            <li>Reduced motion options for users sensitive to animations</li>
            <li>Alternative text for all images and visual elements</li>
            <li>Focus indicators for keyboard navigation</li>
            <li>Semantic HTML structure for better screen reader experience</li>
          </ul>

          <h2>Known Limitations</h2>
          <p>
            Despite our best efforts to ensure accessibility, there may be some limitations. 
            We are actively working to address these issues:
          </p>
          <ul>
            <li>Some complex 3D visualizations may not be fully accessible to screen readers</li>
            <li>Video content may not have complete captions in all cases</li>
            <li>Some interactive elements in the analysis dashboard may require mouse interaction</li>
          </ul>

          <h2>Feedback</h2>
          <p>
            We welcome your feedback on the accessibility of RDV Systems. Please let us know if 
            you encounter accessibility barriers:
          </p>
          <ul>
            <li>Email: <a href="mailto:accessibility@rdvsystems.com">accessibility@rdvsystems.com</a></li>
            <li>Phone: +1 (555) 123-4567</li>
            <li>Address: 123 Technology Drive, Innovation City, IC 12345</li>
          </ul>

          <h2>Formal Complaints</h2>
          <p>
            If you are not satisfied with our response to your accessibility concern, you may 
            file a formal complaint with the relevant authorities in your jurisdiction.
          </p>

          <h2>Technical Specifications</h2>
          <p>
            Accessibility of RDV Systems relies on the following technologies to work with the 
            particular combination of web browser and any assistive technologies or plugins 
            installed on your computer:
          </p>
          <ul>
            <li>HTML</li>
            <li>WAI-ARIA</li>
            <li>CSS</li>
            <li>JavaScript</li>
          </ul>

          <h2>Assessment Approach</h2>
          <p>
            RDV Systems assessed the accessibility of our website by the following approaches:
          </p>
          <ul>
            <li>Self-evaluation using automated accessibility testing tools</li>
            <li>Manual testing with screen readers (NVDA, JAWS, VoiceOver)</li>
            <li>Keyboard-only navigation testing</li>
            <li>User testing with people with disabilities</li>
          </ul>

          <h2>Updates to This Statement</h2>
          <p>
            This accessibility statement is reviewed and updated regularly to reflect any changes 
            to our website or accessibility practices. We encourage users to check this page 
            periodically for updates.
          </p>
        </section>

        <footer className="statement-footer">
          <p>
            This statement was created using the 
            <a href="https://www.w3.org/WAI/planning/statements/" target="_blank" rel="noopener noreferrer">
              W3C Accessibility Statement Generator Tool
            </a>.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default AccessibilityStatement;
